export const selectMessage = ({ alert }) => alert.message;



// WEBPACK FOOTER //
// ./src/core/alert/selectors.js